import { Component, OnInit, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { AdobePageName } from '../../../../../services/adobe-launch/adobe-launch.pages';
import { AdobeLaunchService } from '../../../../../services/adobe-launch/adobe-launch.service';
import { selectContactPersonType } from '../../../../../store/selectors/account-permissions.selector';
import { CONTENT_PLACEHOLDERS } from 'src/common/constants/constants';

import { APPLICATION_ROUTES } from '../../../../../constants/application-routes';
import { TitleService } from '../../../../../services/title/title.service';
import { ContentUtil } from '../../../../../utils/content/content.util';
import { PageComponent } from '../../../page.component';
import { AsyncPipe } from '@angular/common';
import { BackLinkComponent } from '../../../../../components/back-link/back-link.component';
import { RmInfoTileComponent } from '../../../../../components/tiles/rm-info-tile/rm-info-tile.component';
import { ReplaceParamPipe } from '../../../../../pipes/replace-param/replace-param.pipe';

@Component({
    selector: 'zci-remove-from-account-page',
    templateUrl: './remove-from-account-page.component.html',
    imports: [
        AsyncPipe,
        BackLinkComponent,
        RmInfoTileComponent,
        ReplaceParamPipe,
    ],
})
export class RemoveFromAccountPageComponent extends PageComponent implements OnInit {
    private readonly adobeLaunchService = inject(AdobeLaunchService);
    private titleService = inject(TitleService);
    private store = inject(Store);

    content = ContentUtil.content;

    appRoutes = APPLICATION_ROUTES;

    contactPersonType$ = this.store.select(selectContactPersonType);

    contactPersonTypePlaceHolder: string = CONTENT_PLACEHOLDERS.CONTACT_PERSON_TYPE;

    ngOnInit(): void {
        this.titleService.setTitle(
            this.content.accountInterstitialPages.removeAccessFromAccount.pageTitle,
        );
        this.adobeLaunchService.pageLoad(AdobePageName.OBSERVABLE_ACCOUNTS_REMOVE_ACCESS_PAGE);
    }
}
